export type BackupPhoneRelation =
  | 'self'
  | 'father'
  | 'mother'
  | 'sibling'
  | 'relative'
  | 'other';

export interface ScholarshipAcceptanceResponse {
  full_name: string;
  reference_number: string;
  recipient_name: string | null;
  governorate: string | null;
  city: string | null;
  area: string | null;
  street: string | null;
  building: string | null;
  floor: string | null;
  apartment: string | null;
  landmark: string | null;
  postal_code: string | null;
  phone: string | null;
  backup_phone: string | null;
  backup_phone_relation: BackupPhoneRelation | null;
  social_share_consent: boolean | null;
  submitted_at: string | null;
  updated_at: string | null;
}

export interface ScholarshipAcceptancePayload {
  recipient_name: string;
  governorate: string;
  city: string;
  area: string;
  street: string;
  building: string;
  floor: string;
  apartment: string | null;
  landmark: string;
  postal_code: string | null;
  phone: string;
  backup_phone: string;
  backup_phone_relation: BackupPhoneRelation;
  social_share_consent: boolean;
}

export const OTHER_CITY_OPTION = '__other__';

export interface AcceptanceFormValues {
  social_share_consent: boolean | null;
  recipient_name: string;
  governorate: string;
  cityChoice: string;
  customCity: string;
  area: string;
  street: string;
  building: string;
  floor: string;
  apartment: string;
  landmark: string;
  postal_code: string;
  phone: string;
  backup_phone: string;
  backup_phone_relation: BackupPhoneRelation | '';
}

export type AcceptanceFieldKey =
  | 'social_share_consent'
  | 'recipient_name'
  | 'governorate'
  | 'city'
  | 'area'
  | 'street'
  | 'building'
  | 'floor'
  | 'apartment'
  | 'landmark'
  | 'postal_code'
  | 'phone'
  | 'backup_phone'
  | 'backup_phone_relation';

export type AcceptanceFieldErrors = Partial<Record<AcceptanceFieldKey, string>>;
